import React from "react";

export default function ParallaxSection ({children,...rest}:any){
    return (
        <section data-scroll-section {...rest}>
            {children}
        </section>
    )
}